import { Clear, Info } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { green, lightBlue, orange } from "@mui/material/colors";
import React, { useState } from "react";
import { object } from "yup";
import ReactJson from "react-json-view";
import dirtyJSON from "dirty-json";

const AgentChat = ({ chat = {}, close }) => {
  const chatTypes = Object.keys(chat);
  const [chatType, setChatType] = useState(chatTypes[0]);

  const [JsonDate, setJsonData] = useState(null);

  function getJSON(content) {
    let jsonObject;

    try {
      jsonObject = JSON.parse(content);
    } catch (e) {
      try {
        jsonObject = dirtyJSON.parse(content);
      } catch (e2) {
        return content;
      }
    }

    return <pre>{JSON.stringify(jsonObject, null, 2)}</pre>;
  }

  return (
    <>
      <Stack
        border={1}
        borderColor={"divider"}
        direction={"row"}
        width={"100%"}
        height={"100%"}
        overflow={"auto"}
      >
        <Stack flexGrow={1} gap={2} height="100%" overflow="auto" p={1}>
          {chatType === "input_vendor_list" ? (
            <ReactJson
              src={chat[chatType]}
              name={false}
              displayDataTypes={false}
            />
          ) : (
            chat[chatType]?.map((item, index) => {
              let left = index % 2 === 0;
              return (
                <Stack
                  key={index}
                  direction="row"
                  justifyContent={left ? "flex-start" : "flex-end"}
                  gap={1}
                >
                  {left && (
                    <Avatar sx={{ bgcolor: green[500] }}>
                      {item["name"].charAt(0)}
                    </Avatar>
                  )}
                  <Stack
                    gap={1}
                    alignItems={left ? "flex-start" : "flex-end"}
                    maxWidth="75%"
                  >
                    <Typography
                      variant="body2"
                      textAlign={left ? "left" : "right"}
                    >
                      {item["name"]} ({item["role"]})
                    </Typography>
                    <Chip
                      color={left ? "default" : "primary"}
                      sx={{
                        height: "auto",
                        "& .MuiChip-label": {
                          display: "block",
                          whiteSpace: "normal",
                        },
                        fontWeight: "normal",
                        fontSize: 13,
                        borderRadius: left
                          ? "10px 10px 10px 0"
                          : "10px 10px 0 10px",
                        pt: 1,
                        pb: 1,
                      }}
                      label={getJSON(item["content"])}
                    />
                  </Stack>
                  {!left && (
                    <Avatar sx={{ bgcolor: orange[500] }}>
                      {item["name"].charAt(0)}
                    </Avatar>
                  )}
                </Stack>
              );
            })
          )}
        </Stack>

        <List>
          <ListItem
            sx={{ mt: 2, mb: 2 }}
            secondaryAction={
              <IconButton onClick={close}>
                <Clear />
              </IconButton>
            }
          />

          {Object.keys(chat).map(
            (i) =>
              !["entities", "line_items"].includes(i) && (
                <ListItem
                  key={i}
                  secondaryAction={
                    ["entities_chat", "lineitems_chat"].includes(i) && (
                      <IconButton
                        onClick={() =>
                          setJsonData(
                            i === "entities_chat"
                              ? chat["entities"]
                              : chat["line_items"]
                          )
                        }
                      >
                        <Info />
                      </IconButton>
                    )
                  }
                  disablePadding
                >
                  <ListItemButton
                    selected={i === chatType}
                    onClick={() => setChatType(i)}
                  >
                    <ListItemText primary={i} />
                  </ListItemButton>
                </ListItem>
              )
          )}
        </List>
      </Stack>

      <Dialog open={JsonDate} onClose={() => setJsonData(null)}>
        <Box>
          <IconButton onClick={() => setJsonData(null)}>
            <Clear />
          </IconButton>
        </Box>
        <DialogContent>
          {JsonDate && (
            <ReactJson src={JsonDate} name={false} displayDataTypes={false} />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AgentChat;
